import useConsorcioStore from "../../storeModules/useConsorcioStore";

const GroupInfoOptions = () => {
  const { fetchedPlanDetails } = useConsorcioStore.getState();
  const { planoTaxas } = fetchedPlanDetails;
  return planoTaxas;
};

export default GroupInfoOptions;
